;(function () {
  angular.module('contrast.cve').factory('csCveInfoService', csCveInfoService)

  /*TODO i18n-067*/
  /*TODO i18n-068*/
  function csCveInfoService(CVE_SCORE_SEVERITY, $translate) {
    'ngInject'

    var type
    var viewObj

    var service = {
      init: init,
      get: get
    }

    return service

    function init(params) {
      viewObj = {}
      type = params.type
      buildView(params.vuln)
    }

    // application and library vuln/cve responses are different
    // this builds a normalized view object
    function buildView(raw) {
      var transl = {
        title_cveInfoConfidentialityImpact: $translate.instant(
          'title_cveInfoConfidentialityImpact'
        ),
        title_cveInfoIntegrityImpact: $translate.instant(
          'title_cveInfoIntegrityImpact'
        ),
        title_cveInfoAvailabilityImpact: $translate.instant(
          'title_cveInfoAvailabilityImpact'
        ),
        title_cveInfoAuthenticationRequired: $translate.instant(
          'title_cveInfoAuthenticationRequired'
        ),
        title_cveInfoAccessVector: $translate.instant(
          'title_cveInfoAccessVector'
        ),
        title_cveInfoAccessComplexity: $translate.instant(
          'title_cveInfoAccessComplexity'
        )
      }

      if (type === 'lib') {
        viewObj = {
          severityCode: raw.severity_code,
          name: raw.name,
          score: raw.severity_value,
          description: raw.description,
          confidentialityImpact: raw.confidentiality_impact,
          integrityImpact: raw.integrity_impact,
          availabilityImpact: raw.availability_impact,
          authentication: raw.authentication,
          accessVector: raw.access_vector,
          accessComplexity: raw.access_complexity,
          references: raw.references
        }
      } else {
        viewObj = angular.copy(raw)
      }

      if (type === 'app') {
        viewObj.severityCode = calculateAppSeverityCode(viewObj.score)
      }

      // Do not define these options for node "CVEs", because they are not
      // actually CVEs and will possibly have undesirable data such as
      // strings reading "null"
      if (viewObj.name && viewObj.name.toLowerCase().indexOf('cve') === 0) {
        viewObj.impact = [
          {
            label: transl.title_cveInfoConfidentialityImpact,
            value: raw.confidentiality_impact || raw.confidentialityImpact
          },
          {
            label: transl.title_cveInfoIntegrityImpact,
            value: raw.integrity_impact || raw.integrityImpact
          },
          {
            label: transl.title_cveInfoAvailabilityImpact,
            value: raw.availability_impact || raw.availabilityImpact
          }
        ]

        viewObj.other = [
          {
            label: transl.title_cveInfoAuthenticationRequired,
            value: raw.authentication
          },
          {
            label: transl.title_cveInfoAccessVector,
            value: raw.access_vector || raw.accessVector
          },
          {
            label: transl.title_cveInfoAccessComplexity,
            value: raw.access_complexity || raw.accessComplexity
          }
        ]
      }
    }

    function calculateAppSeverityCode(score) {
      if (score >= 7) {
        return CVE_SCORE_SEVERITY.HIGH
      } else if (score >= 4) {
        return CVE_SCORE_SEVERITY.MEDIUM
      }
      return CVE_SCORE_SEVERITY.LOW
    }

    function get() {
      return viewObj
    }
  }
})()
